import React, { useState, useEffect } from "react";
import ContentWrapper from "components/content-wrapper";
import StickyBlock from "components/sticky-block";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import Logo from "components/logo";
import s from "./index.module.scss";
import Share from "components/share";

const covers = [
	{
		image: "images/image1.png",
		background: "images/introbg1.jpg",
		color: "#E31A12"
	},
	{
		image: "images/image2.png",
		background: "images/introbg2.jpg",
		color: "#FD8286"
	},
	{
		image: "images/image3.png",
		background: "images/introbg3.jpg",
		color: "#FBCD32"
	}
];

const Intro = () => {
	const [activeCover, setActiveCover] = useState(0);
	const { length } = covers;

	useEffect(() => {
		const interval = setInterval(() => {
			if (activeCover < length - 1) {
				setActiveCover(activeCover => activeCover + 1);
			} else {
				setActiveCover(0);
			}
		}, 2500);
		return () => clearInterval(interval);
	});

	return (
		<StickyBlock zIndex={101}>
			<div className={s.container}>
				<ContentWrapper as="header" className={s.header}>
					<Logo text className={s.logo} />
					<Share />
				</ContentWrapper>

				<div className={s.contentContainer}>
					<ContentWrapper className={s.content}>
						<div className={s.title}>
							100 моментов <br/>
							<span style={{ color: covers[activeCover].color }}>
								2019
							</span>{" "}
							года
						</div>
						<TransitionGroup className={s.transitionContainerImage}>
							{covers.map((item, i) => {
								return (
									i === activeCover && (
										<CSSTransition
											key={i}
											timeout={400}
											classNames={{ ...s }}
										>
											<div
												className={s.image}
												style={{
													backgroundImage: `url(${item.image})`
												}}
											/>
										</CSSTransition>
									)
								);
							})}
						</TransitionGroup>
						<div className={s.subtitle}>
							<h2>
								в фотографиях
								<span>ТАСС</span>
							</h2>
						</div>
					</ContentWrapper>
				</div>

				<TransitionGroup className={s.transitionContainerBackground}>
					{covers.map((item, i) => {
						return (
							i === activeCover && (
								<CSSTransition
									key={i}
									timeout={400}
									classNames={{ ...s }}
								>
									<div
										className={s.background}
										style={{
											backgroundImage: `url(${item.background})`
										}}
									/>
								</CSSTransition>
							)
						);
					})}
				</TransitionGroup>
			</div>
		</StickyBlock>
	);
};

export default Intro;
